import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DeleteAccountState {
    loading: boolean;
    error: string | null;
    success: boolean;
}

const initialState: DeleteAccountState = {
    loading: false,
    error: null,
    success: false,
};

const deleteAccountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {
        deleteAccountRequest: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        deleteAccountSuccess: (state) => {
            state.loading = false;
            state.success = true;
        },
        deleteAccountFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
            state.success = false;
        },
    },
});

export const { deleteAccountRequest, deleteAccountSuccess, deleteAccountFailure } = deleteAccountSlice.actions;

export const deleteAccountReducer = deleteAccountSlice.reducer;
export const accountActionTypes = deleteAccountSlice.actions;
